import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsYogaNormalMedium = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.013 23.804c.416.188.868.29 1.327.296a3.52 3.52 0 001.5-.34l14.15-6.585V15.09L19 9.09l-9.435 4.122-3.018-1.45-.01.018a3.44 3.44 0 00-1.987-.26 4 4 0 00-3.38 4.13A3.33 3.33 0 003 18.51l.009-.017L13.9 23.75l.072.034.041.02zm.995-1.387l.002-.007a2.13 2.13 0 01-1.51-2v-.07l3 1.53.38-.22a2.92 2.92 0 001.44-3.33 2.66 2.66 0 00-1.56-1.65l-.02-.008.001-.003-5.211-2.503L19 10.91l10.37 5.23-13.23 6.16a1.7 1.7 0 01-1.132.117zm-8.994-9.08l7.564 3.633a3.66 3.66 0 00-1.758 2.96c-.01.157-.01.314 0 .47.001.18.015.358.042.534L3.774 17.03 3.79 17a1.75 1.75 0 01-.99-1.44 2.37 2.37 0 012-2.41 1.81 1.81 0 011.2.21l.014-.024zM14 18.77L16.4 20a1.11 1.11 0 00.37-1.15 1.002 1.002 0 00-.58-.61 1.86 1.86 0 00-.92-.11 2 2 0 00-1.27.64z"
        fill=""
      />
    </svg>
  )
);
SvgSportsYogaNormalMedium.defaultProps = {
  color: 'currentColor',
  size: 32,
  title: undefined,
  titleId: undefined
};
SvgSportsYogaNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsYogaNormalMedium;
